import PropTypes from 'prop-types'
import React from "react"
import { Modal, ModalBody } from "reactstrap"
import i18n from "i18next"
import { withTranslation } from "react-i18next"

const RemoveFromOrganizationModal = ({ show, onRemoveClick, onCloseClick, errorMessage,id }) => {


  return (
    <Modal size="sm" isOpen={show} toggle={onCloseClick} centered={true}>
      <div className="modal-content">
        <ModalBody className="px-4 py-5 text-center">
          <button type="button" onClick={onCloseClick} className="btn-close position-absolute end-0 top-0 m-3"></button>
          <div className="avatar-sm mb-4 mx-auto">
            <div className="avatar-title bg-primary text-primary bg-opacity-10 font-size-20 rounded-3">
              <i className="mdi mdi-trash-can-outline"></i>
            </div>
          </div>
          <p className="text-muted font-size-16 mb-4">{i18n.t("USER.CONFIRM_REMOVE_USER_FROM_ORGANIZATION")}?</p>

          <div className="hstack gap-2 justify-content-center mb-0">
            {!errorMessage && <button type="button" className="btn btn-danger" onClick={()=>onRemoveClick(id)}>{i18n.t("REMOVE_FROM_ORGANIZATION")}</button>}
            <button type="button" className="btn btn-secondary" onClick={onCloseClick}>{i18n.t("CANCEL")}</button>
          </div>
          {errorMessage && <div className="text-danger mt-2">{i18n.t("ERROR")}: {errorMessage}</div>}
        </ModalBody>
      </div>
    </Modal>
  )
}

RemoveFromOrganizationModal.propTypes = {
  onCloseClick: PropTypes.func,
  onRemoveClick: PropTypes.func,
  show: PropTypes.any
}

export default RemoveFromOrganizationModal
